<template>
  <v-container class="recipe-editor-container">
    <v-alert
      prominent
      text
      type="warning"
      v-if="
        recipe && recipe.data.need_configuration === true && dialog !== true
      "
    >
      Cette recette a été créé dans une autre succursale. Les données concernant
      l'inventaire ont été automatiquement copié mais il se pourrait que des
      modifications soient nécessaire pour bien être adapté à cette succursale.
      Si aucune modification est nécessaire, simplement enregistrer la recette.
    </v-alert>
    <v-row
      class="mb-3"
      justify="space-between"
      no-gutters
      v-if="dialog !== true"
    >
      <v-btn
        v-if="recipe"
        exact
        text
        small
        :to="{
          name:
            prevRoute !== null &&
            prevRoute.name !== null &&
            prevRoute.name !== 'RecipeViewer'
              ? prevRoute.name
              : recipe.est_intermediaire === true
              ? 'PreparationIndex'
              : 'RecipeIndex'
        }"
      >
        <v-icon x-small left>fa-chevron-left</v-icon>Retour
      </v-btn>
      <v-btn
        small
        text
        @click="openStats"
        v-if="
          getIsIntermediate &&
            recipe.fk_produit_intermediaire !== null &&
            recipe.id !== null
        "
      >
        Statistiques
        <v-icon x-small right>far fa-chart-bar</v-icon>
      </v-btn>
    </v-row>
    <v-row
      align="center"
      justify="space-between"
      no-gutters
      v-if="id !== null && dialog !== true"
    >
      <v-tooltip right v-if="this.recipe !== undefined">
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            small
            text
            @click="intermediateValueModel = !intermediateValueModel"
            :color="intermediateValueModel ? 'success' : ''"
          >
            <v-icon small left>mdi-food</v-icon>
            Produit final
          </v-btn>
        </template>
        <span>Est un produit final sur le menu</span>
      </v-tooltip>
      <div>
        <RecipeKeyInput
          v-if="this.recipe !== undefined && recipe.data"
          v-model="recipe.data.recipe_key"
        ></RecipeKeyInput>
        <v-tooltip left v-if="recipe && recipe.data">
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              icon
              text
              small
              :color="recipe.data.is_pinned === true ? 'success' : ''"
              @click="recipe.data.is_pinned = !recipe.data.is_pinned"
            >
              <v-icon small>fa-eye</v-icon>
            </v-btn>
          </template>
          Surveiller
        </v-tooltip>
        <v-tooltip left v-if="recipe && recipe.data">
          <template v-slot:activator="{ on }">
            <div v-on="on" style="display: inline;">
              <RecipeCopy :id="id"></RecipeCopy>
            </div>
          </template>
          Copier
        </v-tooltip>
        <v-btn
          icon
          text
          small
          v-if="recipe && recipe.id !== null"
          v-show="!recipe.is_deleted"
          @click="deleteRecipe"
        >
          <v-hover v-slot:default="{ hover }">
            <v-icon small :color="hover ? 'error' : ''">fa-trash</v-icon>
          </v-hover>
        </v-btn>
        <v-btn
          icon
          text
          small
          v-if="recipe && recipe.id !== null"
          v-show="recipe.is_deleted"
          @click="restoreRecipe"
        >
          <v-hover v-slot:default="{ hover }">
            <v-icon small :color="hover ? 'success' : ''"
              >fa-trash-restore</v-icon
            >
          </v-hover>
        </v-btn>
      </div>
    </v-row>
    <v-row v-if="recipe" align="start" class="my-3" no-gutters>
      <v-col cols="12">
        <RecipeTagsEditor v-model="recipe.data.tags"></RecipeTagsEditor>
      </v-col>
    </v-row>
    <section class="recipe-editing" v-if="recipe">
      <v-card class="mb-3">
        <v-card-text>
          <RecipeFields
            v-bind.sync="recipe"
            :prix_vente.sync="recipe.data.prix_vente"
            :recipe-cost.sync="recipe.data.cost"
            :percent-cost.sync="recipe.data.percentCost"
            :recipeCost="recipeCostComputed"
            :percentCost="percentCostComputed"
            :valid.sync="infoValid"
          ></RecipeFields>
        </v-card-text>
      </v-card>
      <v-spacer class="my-1 py-1"></v-spacer>
      <v-tabs
        show-arrows
        slider-color="primary"
        v-model="active"
        background-color="transparent"
      >
        <v-tab>Instructions</v-tab>
        <v-tab v-if="recipe.est_intermediaire">
          <span
            :class="{
              'warning--text': recipe.data.need_configuration === true
            }"
            >Inventaire</span
          ></v-tab
        >
        <v-tab v-if="recipe.est_intermediaire">Expiration</v-tab>
        <v-tab
          v-if="
            recipe.est_intermediaire && recipe.fk_produit_intermediaire !== null
          "
          >Utilisations</v-tab
        >
        <v-tab v-if="recipe.est_intermediaire">Gabarits</v-tab>

        <v-tab-item :eager="true">
          <v-card>
            <v-card-text>
              <RecipeProductionInput
                :valid.sync="productionValid"
                :quantite_produite.sync="recipe.quantite_produite"
                :unite_produite.sync="recipe.unite_produite"
                :always_produce_quantity.sync="recipe.always_produce_quantity"
                :est_intermediaire="recipe.est_intermediaire"
              ></RecipeProductionInput>
              <v-divider class="my-3"></v-divider>
              <RecipeInstructions
                ref="instructionsEditor"
                :instructions="recipe.instructions"
              ></RecipeInstructions>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item :eager="true">
          <v-card>
            <v-card-text>
              <RecipePriceInput
                :quantite_produite.sync="recipe.quantite_produite"
                :quantity_production.sync="recipe.data.quantity_production"
                :quantity_inventory.sync="recipe.data.quantity_inventory"
                :unite_produite.sync="recipe.unite_produite"
                :always_produce_quantity.sync="recipe.always_produce_quantity"
                :cost="recipeCostComputed"
                :unite_inventory.sync="recipe.data.unite_inventory"
                :prix_inventory.sync="recipe.data.prix_inventory"
                :conversion_formula.sync="recipe.data.conversion_formula"
                :use_conversion_formula.sync="
                  recipe.data.use_conversion_formula
                "
                :est_intermediaire="recipe.est_intermediaire"
                :is_pinned.sync="recipe.data.is_pinned"
                :use_expiration_date.sync="recipe.use_expiration_date"
                :expiration_date_timer.sync="recipe.expiration_date_timer"
                :expiration_date_threshold.sync="
                  recipe.expiration_date_threshold
                "
                :use_auto_expiration_waste.sync="
                  recipe.use_auto_expiration_waste
                "
                :comments_inventory.sync="recipe.data.comments_inventory"
                :valid.sync="priceValid"
              ></RecipePriceInput>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item :eager="true">
          <v-card>
            <v-card-text>
              <RecipePriceInput
                expiration
                :quantite_produite.sync="recipe.quantite_produite"
                :quantity_production.sync="recipe.data.quantity_production"
                :quantity_inventory.sync="recipe.data.quantity_inventory"
                :unite_produite.sync="recipe.unite_produite"
                :always_produce_quantity.sync="recipe.always_produce_quantity"
                :cost="recipeCostComputed"
                :unite_inventory.sync="recipe.data.unite_inventory"
                :prix_inventory.sync="recipe.data.prix_inventory"
                :conversion_formula.sync="recipe.data.conversion_formula"
                :use_conversion_formula.sync="
                  recipe.data.use_conversion_formula
                "
                :est_intermediaire="recipe.est_intermediaire"
                :is_pinned.sync="recipe.data.is_pinned"
                :use_expiration_date.sync="recipe.use_expiration_date"
                :expiration_date_timer.sync="recipe.expiration_date_timer"
                :expiration_date_threshold.sync="
                  recipe.expiration_date_threshold
                "
                :use_auto_expiration_waste.sync="
                  recipe.use_auto_expiration_waste
                "
                :comments_inventory.sync="recipe.data.comments_inventory"
                :valid.sync="priceValid"
              ></RecipePriceInput>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item
          v-if="
            recipe.est_intermediaire && recipe.fk_produit_intermediaire !== null
          "
        >
          <v-card>
            <v-card-text>
              <ProductRecipeLinkGrid
                :id="recipe.fk_produit_intermediaire"
              ></ProductRecipeLinkGrid>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item v-if="recipe.est_intermediaire">
          <v-card>
            <v-card-text>
              <ProductPreparationSlipAdder
                ref="prepSlipAdder"
                :id="recipe.fk_produit_intermediaire"
                :recipe="recipe"
              ></ProductPreparationSlipAdder>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>

      <div class="mt-3">
        <IngredientTab
          ref="ingredients"
          :recipe-id="id"
          :ingredients.sync="recipe.ingredients"
          :intermediate-product="recipe.fk_produit_intermediaire"
          :valid.sync="ingredientsValid"
          :open-editors.sync="openEditors"
        ></IngredientTab>
      </div>

      <v-row align="center" justify="end" no-gutters style="margin-top: 4rem;">
        <v-btn
          class="mx-0"
          color="success"
          @click="saveRecipe"
          :block="$vuetify.breakpoint.xsOnly"
          :large="$vuetify.breakpoint.smAndDown"
          :disabled="getFormIsValid === false"
        >
          <v-icon small left>fa-save</v-icon>Enregistrer
        </v-btn>
      </v-row>
    </section>
  </v-container>
</template>

<script>
import round10 from "round10";
import {
  RecipeFields,
  RecipeTagsEditor,
  RecipeInstructions,
  RecipePriceInput,
  RecipeKeyInput,
  RecipeCopy
} from "../components";
import RecipeProductionInput from "../components/RecipeProductionInput.vue";
import IngredientTab from "../components/IngredientTab.vue";
import ProductPreparationSlipAdder from "../components/ProductPreparationSlipAdder";
import { rulesMixin } from "@/mixins/rulesMixins";
import { mapGetters } from "vuex";
import { api } from "@/api";
import { mappers } from "@/mappers";
import * as Sentry from "@sentry/browser";
export default {
  mixins: [rulesMixin],
  name: "RecipeEditor",
  props: {
    id: {
      default: null
    },
    dialog: {
      type: Boolean,
      default: false
    },
    openEditors: {
      default: () => []
    },
    isFinalRecipe: {
      type: Boolean,
      default: false
    }
  },
  components: {
    RecipeFields,
    RecipeTagsEditor,
    RecipeInstructions,
    RecipePriceInput,
    RecipeKeyInput,
    ProductPreparationSlipAdder,
    IngredientTab,
    RecipeCopy,
    RecipeProductionInput
  },
  beforeRouteEnter(to, from, next) {
    next(async vm => {
      vm.prevRoute = from;
      await vm.getData();
    });
  },
  async beforeRouteUpdate(to, from, next) {
    await this.getData();
    next();
  },
  async beforeRouteLeave(to, from, next) {
    if (this.recipeChanged === true) {
      const res = await this.$dialog.confirm({
        text:
          "Voulez-vous enregistrer les modifications avant de quitter la page?",
        title: "",
        actions: {
          false: "Non",
          true: "Oui"
        }
      });
      this.recipeChanged = false;
      if (res === true && this.getFormIsValid === true) {
        await this.saveRecipe();
        next();
      } else if (res === false) {
        next();
      }
    } else {
      next();
    }
  },
  computed: {
    ...mapGetters([
      "getCustomUnits",
      "getAllowedUnits",
      "getStoreId",
      "getProducts",
      "getOrganisationId",
      "getAuthHeader",
      "getIngredients",
      "getRecipeLoading",
      "getProductLoading"
    ]),
    percentCostComputed() {
      return this.recipe.data && this.recipe.data.prix_vente > 0
        ? round10.round10(
            (this.recipeCostComputed / this.recipe.data.prix_vente) * 100,
            -4
          )
        : 0;
    },
    recipeCostComputed() {
      const cost = this.recipe.ingredients
        .filter(x => x.is_deleted !== true)
        .map(x => this.getIngredientCost(x))
        .reduce((a, b) => a + b, 0);
      return round10.round10(cost, -4);
    },
    getIngredientsAllergens() {
      return [
        ...new Set(
          this.recipe.ingredients
            .filter(x => x.is_deleted === false)
            .map(x => {
              if (
                this.getProducts.find(p => p.id === x.pk_recette_produit) &&
                this.getProducts.find(p => p.id === x.pk_recette_produit).data
              ) {
                const product = this.getProducts.find(
                  p => p.id === x.pk_recette_produit
                );
                if (product.data.allergens.length > 0) {
                  return product.data.allergens;
                } else {
                  return [];
                }
              }
            })
            .flat()
        )
      ].filter(x => x !== undefined);
    },
    getIsIntermediate() {
      if (this.recipe !== undefined && this.recipe.est_intermediaire === true) {
        return true;
      } else {
        return false;
      }
    },
    getFormIsValid() {
      return (
        this.infoValid === true &&
        (this.priceValid === true || this.recipe.est_intermediaire === false) &&
        this.recipe.ingredients.filter(x => x.is_deleted === false).length >
          0 &&
        this.ingredientsValid === true &&
        this.productionValid === true
      );
    },
    intermediateValueModel: {
      get() {
        if (this.recipe) {
          return !this.recipe.est_intermediaire;
        } else {
          return false;
        }
      },
      set(newValue) {
        this.recipe.est_intermediaire = !newValue;
      }
    }
  },
  data() {
    return {
      active: 0,
      editDialog: false,
      saving: false,
      loading: "primary",
      rowsPerPageItems: [100],
      unitSelection: ["g", "ml", "un", "kg", "l", "lb"],
      recipe: undefined,
      newIngredientIsValid: false,
      infoValid: false,
      priceValid: false,
      ingredientsValid: true,
      productionValid: false,
      addIngredient: {
        id: null,
        quantity: null,
        ordre: null
      },
      editIngredientData: {
        unite_mesure: null,
        id: null
      },
      headers: [
        { value: "ordre", text: "Ordre", width: 75, class: "px-2" },
        { value: "nom", text: "Nom", class: "px-1" },
        { value: "quantite", text: "Quantité", width: 100, class: "px-1" },
        { value: "", text: "", width: 100, class: "px-1" },
        { value: "prix", text: "Prix", class: "px-1 hidden-xs-only" },
        { value: "cost", text: "Coût", class: "px-1 hidden-xs-only" },
        {
          value: "comments",
          text: "Instruction",
          class: "px-1 hidden-xs-only"
        },
        { value: "", text: "", width: 50 }
      ],
      pagination: { sortBy: "ordre", ascending: true, rowsPerPage: 100 },
      prevRoute: null,
      recipeChanged: false
    };
  },
  methods: {
    async getData() {
      try {
        this.loading = true;
        this.$store.dispatch("slo");
        this.$store.dispatch("loadTagCategories");
        await this.$store.dispatch("loadAllRecipeStore");
        if (this.id !== null) {
          this.recipe = await api.retrieveRecipe(this.id);
          if (this.recipe.data === null) {
            this.recipe.data = {
              fk_recipe: this.id,
              store: this.getStoreId,
              prix_vente: 0,
              cost: 0,
              tags: [],
              prix_inventory: null,
              unite_inventory: null,
              conversion_formula: null,
              use_conversion_formula: false,
              quantity_inventory: 1,
              quantity_production: null,
              recipe_key: null,
              is_pinned: false,
              comments_inventory: null,
              need_configuration: false
            };
          } else if (this.recipe.data.need_configuration === true) {
            this.active = 2;
          }
          this.recipe.ingredients
            .filter(x => x.unite_mesure === null)
            .forEach(x => {
              const product = this.getProducts.find(
                p => p.id === x.pk_recette_produit
              );
              if (product && product.data) {
                x.unite_mesure = product.data.use_conversion_formula
                  ? product.data.unite_mesure
                  : product.data.unite_mesure_inventory;
              }
            });
          if (this.recipe.data.tags === null) {
            this.recipe.data.tags = [];
          }
          if (this.recipe.data.allergens === null) {
            this.recipe.data.allergens = [];
          }
          if (
            this.recipe.instruction &&
            Object.entries(this.recipe.instructions).length === 0 &&
            this.recipe.instructions.constructor === Object
          ) {
            const lines = this.recipe.instruction.split("\n");
            this.recipe.instructions = {
              time: Date.now(),
              blocks: [
                ...lines.map(x => {
                  return {
                    type: "paragraph",
                    data: {
                      text: x
                    }
                  };
                })
              ],
              version: "2.15.1"
            };
          }
        } else {
          this.recipe = {
            organisation: this.getOrganisationId,
            nom: "",
            quantite_produite: 1,
            unite_produite: null,
            est_intermediaire: this.isFinalRecipe === true ? false : true,
            always_produce_quantity: false,
            fk_produit_intermediaire: null,
            is_deleted: false,
            recipe_quantity_reference: null,
            use_inventory_link: false,
            use_expiration_date: false,
            expiration_date_timer: 0,
            expiration_date_threshold: 0,
            use_auto_expiration_waste: false,
            instructions: {
              time: Date.now(),
              blocks: [],
              version: "2.15.1"
            },
            tags: [],
            allergens: [],
            ingredients: [],
            data: {
              fk_recipe: null,
              store: this.getStoreId,
              prix_vente: 0,
              cost: 0,
              tags: [],
              prix_inventory: null,
              unite_inventory: null,
              conversion_formula: null,
              use_conversion_formula: false,
              quantity_inventory: 1,
              quantity_production: null,
              recipe_key: null,
              is_pinned: false,
              comments_inventory: null,
              need_configuration: false
            }
          };
        }
      } finally {
        this.$store.dispatch("elo");
        this.recipeChanged = false;
        this.loading = false;
      }
    },
    async saveRecipe() {
      if (this.getFormIsValid === true) {
        const instructions = await this.$refs.instructionsEditor.save();
        const data = {
          ...this.recipe,
          instructions: instructions,
          quantite_produite: round10.round10(this.recipe.quantite_produite, -4),
          allergens: this.getIngredientsAllergens,
          use_inventory_link:
            this.recipe.ingredients.filter(x => x.is_inventory_link === true)
              .length > 0
        };
        data.data = { ...this.recipe.data };
        data.data.tags =
          this.recipe.data.tags.length > 0 ? this.recipe.data.tags : undefined;
        data.data.allergens = this.getIngredientsAllergens;
        data.data.prix_vente = round10.round10(this.recipe.data.prix_vente, -2);
        data.data.cost = round10.round10(this.recipeCostComputed, -2);
        data.data.prix_inventory = round10.round10(
          mappers.recipeProdPriceToInvPrice(data.data.cost, data, data.data),
          -2
        );
        data.ingredients.forEach(x => {
          if (Number.isNaN(x.ordre)) x.ordre = null;
        });
        try {
          this.$store.dispatch("startLoadingOverlay");
          let r = undefined;
          if (this.id !== null) {
            r = await api.patchRecipe(this.id, data);
          } else {
            r = await api.postRecipe(data);
          }
          if (r !== undefined && r.fk_produit_intermediaire !== null) {
            if (this.$refs.prepSlipAdder !== undefined) {
              await this.$refs.prepSlipAdder.saveTemplateValues(
                r.fk_produit_intermediaire
              );
            }
          }
          this.recipeChanged = false;
          if (this.dialog !== true)
            this.$router.push({
              name:
                this.recipe.est_intermediaire === true
                  ? "PreparationIndex"
                  : "RecipeIndex"
            });
          this.$emit("save");
        } finally {
          this.$store.dispatch("endLoadingOverlay");
        }
      }
    },
    async toggleDeleteRecipe() {
      const data = {
        is_deleted: !this.recipe.is_deleted
      };
      try {
        this.$store.dispatch("startLoadingOverlay");
        await api.patchSimpleRecipe(this.id, data);
      } finally {
        this.$store.dispatch("endLoadingOverlay");
      }
    },
    getIngredientCost(item) {
      try {
        const product = this.getProducts.find(
          x => x.id === item.pk_recette_produit
        );
        if (product && product.data) {
          if (product.data.use_conversion_formula) {
            if (product.data.use_alternative_unit === true) {
              let alt_unit_possibilities = [];
              if (
                !mappers.isCustomUnit(
                  product.data.alternative_unite_mesure_production
                )
              ) {
                alt_unit_possibilities = this.$units()
                  .from(product.data.alternative_unite_mesure_production)
                  .possibilities()
                  .filter(x => this.getAllowedUnits.includes(x));
              } else {
                alt_unit_possibilities = this.getCustomUnits.map(x => x.name);
              }
              const is_alternative_unite_mesure = alt_unit_possibilities.includes(
                item.unite_mesure
              );
              if (is_alternative_unite_mesure) {
                if (
                  !mappers.isCustomUnit(item.unite_mesure) &&
                  !mappers.isCustomUnit(
                    product.data.alternative_unite_mesure_production
                  )
                ) {
                  const itemQtyInProductUnit = this.$units(item.quantite)
                    .from(item.unite_mesure)
                    .to(product.data.alternative_unite_mesure_production);
                  return round10.round10(
                    Number(product.data.alternative_price) *
                      itemQtyInProductUnit,
                    -4
                  );
                } else {
                  return round10.round10(
                    Number(product.data.alternative_price) * item.quantite,
                    -4
                  );
                }
              } else {
                if (
                  !mappers.isCustomUnit(item.unite_mesure) &&
                  !mappers.isCustomUnit(product.data.unite_mesure)
                ) {
                  const itemQtyInProductUnit = this.$units(item.quantite)
                    .from(item.unite_mesure)
                    .to(product.data.unite_mesure);
                  return round10.round10(
                    Number(product.data.prix) * itemQtyInProductUnit,
                    -4
                  );
                } else {
                  return round10.round10(
                    Number(product.data.prix) * item.quantite,
                    -4
                  );
                }
              }
            } else {
              if (
                !mappers.isCustomUnit(item.unite_mesure) &&
                !mappers.isCustomUnit(product.data.unite_mesure)
              ) {
                const itemQtyInProductUnit = this.$units(item.quantite)
                  .from(item.unite_mesure)
                  .to(product.data.unite_mesure);
                return round10.round10(
                  Number(product.data.prix) * itemQtyInProductUnit,
                  -4
                );
              } else {
                return round10.round10(
                  Number(product.data.prix) * item.quantite,
                  -4
                );
              }
            }
          } else {
            if (
              !mappers.isCustomUnit(item.unite_mesure) &&
              !mappers.isCustomUnit(product.data.unite_mesure_inventory)
            ) {
              const itemQtyInProductUnit = this.$units(item.quantite)
                .from(item.unite_mesure)
                .to(product.data.unite_mesure_inventory);
              return round10.round10(
                (Number(product.data.prix_inventory) /
                  product.data.quantity_inventory) *
                  itemQtyInProductUnit,
                -4
              );
            } else {
              return round10.round10(
                (Number(product.data.prix_inventory) /
                  product.data.quantity_inventory) *
                  item.quantite,
                -4
              );
            }
          }
        } else {
          console.error("Product not found");
          return 0;
        }
      } catch (e) {
        Sentry.captureException(e);
        console.error(e);
        return 0;
      }
    },
    async deleteRecipe() {
      try {
        const tasks = [];
        this.$store.dispatch("startLoadingOverlay");
        this.recipe.is_deleted = true;
        if (
          this.recipe.est_intermediaire &&
          this.recipe.fk_produit_intermediaire !== null
        ) {
          tasks.push(
            api.patchSimpleRecipeProduct(this.recipe.fk_produit_intermediaire, {
              is_deleted: true
            })
          );
        }
        tasks.push(api.patchSimpleRecipe(this.id, { is_deleted: true }));
        await Promise.all(tasks);
        this.recipeChanged = false;
        this.$router.push({
          name:
            this.recipe.est_intermediaire === true
              ? "PreparationIndex"
              : "RecipeIndex"
        });
      } finally {
        this.$store.dispatch("endLoadingOverlay");
      }
    },
    async restoreRecipe() {
      try {
        const tasks = [];
        this.$store.dispatch("startLoadingOverlay");
        this.recipe.is_deleted = false;
        if (
          this.recipe.est_intermediaire &&
          this.recipe.fk_produit_intermediaire !== null
        ) {
          tasks.push(
            api.patchSimpleRecipeProduct(this.recipe.fk_produit_intermediaire, {
              is_deleted: false
            })
          );
        }
        tasks.push(api.patchSimpleRecipe(this.id, { is_deleted: false }));
        await Promise.all(tasks);
        this.recipeChanged = false;
        this.$router.push({ name: "RecipeIndex" });
      } finally {
        this.$store.dispatch("endLoadingOverlay");
      }
    },
    async openStats() {
      this.$router.push({
        name: "StatisticsDetails",
        params: { id: this.recipe.fk_produit_intermediaire }
      });
    },
    recipeChangeHandler(nV, oV) {
      if (oV !== undefined) {
        this.recipeChanged = true;
      }
    }
  },
  watch: {
    recipe: {
      deep: true,
      handler: "recipeChangeHandler"
    },
    getRecipeLoading(v, oldV) {
      if (v === true && oldV === false) {
        this.$store.dispatch("slo");
      } else {
        this.$store.dispatch("elo");
      }
    },
    getProductLoading(v, oldV) {
      if (v === true && oldV === false) {
        this.$store.dispatch("slo");
      } else {
        this.$store.dispatch("elo");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.hover-row:hover {
  opacity: 0.8;
  cursor: pointer;
}
.align-icon-right {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}
</style>
